import React from "react"
import {BasePopup} from "uiKit"
import {BaseButton, SecondaryButton} from "components/buttons/Button"
import {formatDateOnly} from "helpers"
import {useModel} from "hooks"
import styles from "./DeleteAttendanceBeforeStartDatePopup.module.css"

type Props = {
    isVisible: boolean
    previousStartDate?: string | null
    newStartDate?: string | null
    loading?: boolean
    onClose: () => void
    onConfirmNo: () => void
    onConfirmYes: () => void
}

const DeleteAttendanceBeforeStartDatePopup = ({
    isVisible,
    previousStartDate,
    newStartDate,
    loading = false,
    onClose,
    onConfirmNo,
    onConfirmYes
}: Props) => {
    const model = useModel()
    const userDateFormat = model.getUserDateFormat()

    return (
        <BasePopup
            isShow={isVisible}
            onClose={onClose}
            leftIcon="WARNING_SOLID"
            leftIconColor="#fff"
            width="440px"
            zIndex={1100}>
            <div className={styles.root}>
                <div className={styles.title}>Delete previous attendance?</div>
                <div className={styles.body}>
                    Previous start date: <strong>{formatDateOnly(previousStartDate, userDateFormat, "-")}</strong>
                    <br />
                    New start date: <strong>{formatDateOnly(newStartDate, userDateFormat, "-")}</strong>
                    <br />
                    <br />
                    Do you want to delete attendance records before the new start date?
                </div>
                <div className={styles.footer}>
                    <SecondaryButton title="Cancel" onClick={onClose} disabled={loading} />
                    <SecondaryButton title="No" onClick={onConfirmNo} disabled={loading} />
                    <BaseButton title="Yes" onClick={onConfirmYes} loading={loading} />
                </div>
            </div>
        </BasePopup>
    )
}

export default DeleteAttendanceBeforeStartDatePopup
